import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// 布局状态管理
interface LayoutState {
	// 侧边栏状态
	sidebarCollapsed: boolean
	sidebarOpen: boolean // 移动端抽屉状态
	setSidebarCollapsed: (collapsed: boolean) => void
	setSidebarOpen: (open: boolean) => void
	toggleSidebar: () => void
	toggleMobileSidebar: () => void

	// 主题状态
	theme: 'light' | 'dark' | 'system'
	setTheme: (theme: 'light' | 'dark' | 'system') => void
}

export const useLayoutStore = create<LayoutState>()(
	persist(
		(set) => ({
			// 侧边栏默认展开
			sidebarCollapsed: false,
			sidebarOpen: false,
			setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
			setSidebarOpen: (open) => set({ sidebarOpen: open }),
			toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
			toggleMobileSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

			// 主题默认跟随系统
			theme: 'system',
			setTheme: (theme) => set({ theme }),
		}),
		{
			name: 'carrot-admin-layout',
			partialize: (state) => ({
				sidebarCollapsed: state.sidebarCollapsed,
				theme: state.theme,
			}),
		}
	)
)
